const events = {
    "default": { 
        title: "Descope Events",
        subtitle: "Event Check-In",
        desc: "Easy way to check into events, and have your name tag printed.",
        flow: "checkin"
    },
    "rsa2025": {
        title: "RSA Happy Hour",
        subtitle: "",
        desc: "Check in and get your name tag printed.",
        flow: "checkin"

    },
    "funda2025": {
        title: "FUNDA WINTER 2025 Event",
        subtitle: "",
        desc: "Check in and get your name tag printed.",
        flow: "auto-print-auth-signup",
        labelHeader: "< authenticated with descope.com />"

    },
    "raffle": {
        title: "Raffle Event",
        subtitle: "Register for our raffle below",
        desc: "Register for our raffle below.",
        flow: "raffle"
    }, 
    "kcraffle": {
        title: "KCDC 2025",
        subtitle: "Descope Raffle",
        desc: "Register for our raffle below.",
        flow: "raffle"
    },
    "mcphack": {
        title: "MCP Global Hackathon",
        subtitle: "",
        desc: "Check in and get your name tag printed.",
        flow: "auto-print-auth-signup",
        labelHeader: "< Descope MCP Hackathon />"
    },
    "count": {
        title: "Descope Events",
        subtitle: "",
        desc: "Easy way to check into events, and have your name tag printed.",
        flow: "count"
    },
    "tc2025": {
        title: "Founders Happy Hour and Fireside Chat",
        subtitle: "",
        desc: "Check in and get your name tag printed.",
        flow: "auto-print-auth-signup",
        labelHeader: "< Founders Happy Hour and Fireside Chat />"
    },
    "dscp2026beta": {
        title: "Descope 2026 Predictions",
        subtitle: "",
        desc: "Predict your numbers and win a chance to drive Slavik's Tesla..",
        flow: "sign-up-or-in",
        projectId: "P36kacGyWMp4JPailefnD50cz7wo"
    }
}

export default events;